<template>
  <div class="mask searchFilter" :class="{ fixed: mask}">
    <div class="search" style="background-color:#ffffff;position:fixed">
      <div class="search-head" style=" width: 100%;  justify-content: left; ">
        <div style=" width: 90%;">
          <form action="" style="width: 100%;justify-content: space-between;position: relative;"
            class="flex between align">
            <input class="search-head-input searchBImg" v-model="input" :placeholder="placeholder"
              style=" width: 98%; " @keyup.enter="onFilter" @focus="onBlur" @close="onClose">
            <!-- <i class="fa fa-close clear" v-show="input" @click.stop="input = ''"></i> -->
            <img @click="onReset" src="../assets/close.png" class="fa fa-close clear" style=" right: 4%; "
              v-show="input" @click.stop="input = ''">
          </form>
        </div>
        <div style="width:5%;margin-top: 8px">
          <div @click.stop="onFilter">
            <!-- <icon type="searchFilter" :sizeW="13" :sizeH="13" class="searchFilter-icon" /> -->
            <img src="../assets/search.svg" class="searchFilter-searchImg">
          </div>
        </div>

      </div>

    </div>

    <slot name="searchMore"></slot>

  </div>
</template>
<script>
import {
  Toast
} from 'mint-ui';
export default {
  name: 'SearchFilter',
  props: {
    mask: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    init: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      input: this.init,
      body: {
        name: '',
        page: {
          pageNo: 1,
          pageSize: 5
        }
      }
    }
  },
  methods: {
    onReset() {
      
      this.$emit('resetSearch')
    },
    onClose() {
      console.log(2)
      this.$emit('close')
    },
    onFilter() {
      let inputVal = this.input.trim()
      if (inputVal == '') {
        Toast('请输入关键词')
        return
      }
      this.body.criteria = {};
      this.body.criteria.name = inputVal
      this.$emit('search', this.body)
    },
    onBlur() {
      window.scroll(0, 0);
      // document.activeElement.blur()
    },
  },
};

</script>
<style lang="stylus">
  @import '../stylus/components/search.styl'
  .flex.between {
      justify-content: space-between /*水平居中*/;
  }
  .searchBImg{
    background: url('../assets/searchImg.png') 10px no-repeat;
    background-color: #f5f5f5
    background-size: 12px;
  }
  .search-head-input {
    padding-left: 25px;
  }
  .searchFilter{
    z-index :10
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchFilter.vue